import chatboxController from './chatboxController'
import commentsController from './comments/commentsController'
import chatboxServices from './chatboxServices'

export default angular.module('app.chatbox', [chatboxServices])
  .controller('ChatboxController', chatboxController)
  .controller('CommentsController', commentsController)
  .name



// WEBPACK FOOTER //
// ./src/app/u-faculty/chatbox/index.js